module.exports = __webpack_public_path__ + "img/connected.839295c8.svg";